import { useCallback } from 'react';

import useAuth from '@/data/hook/useAuth';
import { canAccessMultipleUnits } from '@/utils/canAccessMultipleUnits';
import { getAuthorizedUnits } from '@/utils/getAuthorizedUnits';

type AuthorizedUnits = {
  canFilterByUnit: boolean;
  authorizedUnits?: number[];
  isAuthorizedUnit: (unit?: number) => boolean;
};

export default function useAuthorizedUnits(): AuthorizedUnits {
  const { user } = useAuth();

  const canFilterByUnit = user ? canAccessMultipleUnits(user) : false;
  const authorizedUnits = getAuthorizedUnits(user);

  const isAuthorizedUnit = useCallback(
    (unit?: number) =>
      !!unit && (!authorizedUnits || authorizedUnits.includes(unit)),
    [authorizedUnits],
  );

  return { canFilterByUnit, authorizedUnits, isAuthorizedUnit };
}
